import { useDevice } from "../contexts/deviceContext";
import { useViewportSize } from "../contexts/viewPortSizeContext";

export const useIsMobileView = (): boolean => {
  const { isMobile } = useDevice();
  const { md } = useViewportSize();
  return isMobile || !md;
};
